import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'OrganizationActivity';
const ENDPOINT = `/organization-activities/`;

@Injectable({
    providedIn: 'root'
})
export class OrganizationActivityService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
